import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const deletecontact = (state) => {

  return axios.delete(API + "parties/delete-contact/"+state+"/",{headers: authHeader(),});
};

const ActiveContact = (state) => {

  return axios.delete(API + "parties/contact-active/"+state+"/",{headers: authHeader(),});
};
const InActiveContact = (state) => {

  return axios.delete(API + "parties/contact-inactive/"+state+"/",{headers: authHeader(),});
};

const DeleteContactService = {
    deletecontact,
    ActiveContact,
    InActiveContact
  };
  export default DeleteContactService;